import React from "react";
import { SETTINGS_DETAILS_LIST } from "../../../constants";

const TableHeader = ({ settingDetails }) => {
  const title = settingDetails?.title;
  const updatedTitle = title === "Attributes" ? "Attribute Library" : title;
  return (
    <div className="flex flex-col justify-start h-fit">
      <p className="text-es-black tracking-es-xwide text-es-xl font-es-semibold">
        {updatedTitle}
      </p>
      {settingDetails?.title !==
        SETTINGS_DETAILS_LIST.PREFERENCES_LIBRARY.title && ( // Preferences Design doesn't have description
        <p className="text-es-normal font-es-semibold tracking-es-wide text-es-medium-grey">
          {settingDetails?.description}
        </p>
      )}
    </div>
  );
};

export default TableHeader;
